import ResourceLink from 'components/common/digitalResourcesMaps/resourceLink';
import React, { useCallback } from 'react';
import { IDResource, MapGroupProps } from 'types';
import { getPictureByUrl, onFaviconError } from 'utils/helpers/resourcesMap';

const ArtLink: React.FC<MapGroupProps> = ({
  resources,
  onHoveredElementChanged,
  onClick,
}) => {
  const onElementHover = useCallback(
    (resource?: IDResource, target?: SVGElement) => {
      if (onHoveredElementChanged) {
        onHoveredElementChanged(resource, target);
      }
    },
    [onHoveredElementChanged]
  );

  const resource1SVGComponent = (
    <g
      className="icon-link"
      pointerEvents="none"
      transform="translate(-48 95) rotate(-8)"
    >
      <rect
        x="0"
        y="0"
        width="67"
        height="67"
        rx="13.34"
        fill="#fff"
        stroke="#98eeff"
        strokeMiterlimit="10"
        strokeWidth="4"
      />
      <image
        width="54"
        height="54"
        transform="translate(6.5 6.5)"
        href={getPictureByUrl(resources[0]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource2SVGComponent = (
    <g
      className="icon-link"
      pointerEvents="none"
      transform="translate(33 88) rotate(-5)"
    >
      <rect
        x="0"
        y="0"
        width="67"
        height="67"
        rx="13.34"
        fill="#fff"
        stroke="#98eeff"
        strokeMiterlimit="10"
        strokeWidth="4"
      />
      <image
        width="54"
        height="54"
        transform="translate(6.5 6.5)"
        href={getPictureByUrl(resources[1]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource3SVGComponent = (
    <g
      className="icon-link"
      pointerEvents="none"
      transform="translate(122 82) rotate(5)"
    >
      <rect
        x="0"
        y="0"
        width="67"
        height="67"
        rx="13.34"
        fill="#fff"
        stroke="#98eeff"
        strokeMiterlimit="10"
        strokeWidth="4"
      />
      <image
        width="54"
        height="54"
        transform="translate(6.5 6.5)"
        href={getPictureByUrl(resources[2]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource4SVGComponent = (
    <g
      className="icon-link"
      pointerEvents="none"
      transform="translate(-60 22) rotate(-16)"
    >
      <rect
        x="0"
        y="0"
        width="67"
        height="67"
        rx="13.34"
        fill="#fff"
        stroke="#98eeff"
        strokeMiterlimit="10"
        strokeWidth="4"
      />
      <image
        width="54"
        height="54"
        transform="translate(6.5 6.5)"
        href={getPictureByUrl(resources[3]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );
  const resource5SVGComponent = (
    <g
      className="icon-link"
      pointerEvents="none"
      transform="translate(24 10) rotate(-10)"
    >
      <rect
        x="0"
        y="0"
        width="67"
        height="67"
        rx="13.34"
        fill="#fff"
        stroke="#98eeff"
        strokeMiterlimit="10"
        strokeWidth="4"
      />
      <image
        width="54"
        height="54"
        transform="translate(6.5 6.5)"
        href={getPictureByUrl(resources[4]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource6SVGComponent = (
    <g
      className="icon-link"
      pointerEvents="none"
      transform="translate(117 0) rotate(8)"
    >
      <rect
        x="0"
        y="0"
        width="67"
        height="67"
        rx="13.34"
        fill="#fff"
        stroke="#98eeff"
        strokeMiterlimit="10"
        strokeWidth="4"
      />
      <image
        width="54"
        height="54"
        transform="translate(6.5 6.5)"
        href={getPictureByUrl(resources[5]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  return (
    <g className="digital-resources-art" transform="translate(564.5, 537)">
      <defs>
        <radialGradient
          id="ef6373f0-66c7-4d3c-b248-ffa9e6daad18"
          data-name="grad-2"
          cx="346.7"
          cy="126.57"
          r="3.41"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#fff" stopOpacity="0.3" />
          <stop offset="0.51" stopColor="#7fff7f" stopOpacity="0.65" />
          <stop offset="1" stopColor="lime" />
        </radialGradient>
        <radialGradient
          id="f2d7ddae-7d23-41a5-bf37-52c032b62bb4"
          data-name="grad-3"
          cx="337.2"
          cy="128.08"
          r="2.39"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#fff" stopOpacity="0.5" />
          <stop offset="0.13" stopColor="#f7d1df" stopOpacity="0.6" />
          <stop offset="0.38" stopColor="#e87fa5" stopOpacity="0.77" />
          <stop offset="0.62" stopColor="#dd447c" stopOpacity="0.9" />
          <stop offset="0.84" stopColor="#d62163" stopOpacity="0.97" />
          <stop offset="1" stopColor="#d4145a" />
        </radialGradient>
        <radialGradient
          id="fe9792e0-e9ff-4f32-a022-f189d8953ced"
          data-name="grad-81"
          cx="322.2"
          cy="243.76"
          r="20.6"
          gradientTransform="translate(0 -93.71) scale(1 0.87)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#008b78" />
          <stop offset="0.6" stopColor="#00dfda" stopOpacity="0.56" />
          <stop offset="0.95" stopColor="aqua" stopOpacity="0.4" />
        </radialGradient>
        <radialGradient
          id="ba153504-5bf4-4c43-a385-10b7c52f4eb6"
          data-name="grad-86"
          cx="322.2"
          cy="87.9"
          r="22.21"
          gradientTransform="matrix(-0.01, -0.87, 2.15, -0.03, 138.03, 400.97)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.21" stopColor="#008b78" />
          <stop offset="0.39" stopColor="#00a293" stopOpacity="0.84" />
          <stop offset="0.77" stopColor="#00ded8" stopOpacity="0.43" />
          <stop offset="0.95" stopColor="aqua" stopOpacity="0.2" />
        </radialGradient>
        <radialGradient
          id="ba9af3b4-47a9-4f4b-a282-329720f796fe"
          cx="321.64"
          cy="97.8"
          r="25.35"
          gradientTransform="matrix(1, 0, 0, 1, 0, 0)"
          xlinkHref="#fe9792e0-e9ff-4f32-a022-f189d8953ced"
        />
        <radialGradient
          id="ff3e5164-0cfa-4a27-a567-5f0cae925559"
          cx="321.64"
          cy="97.8"
          r="25.39"
          gradientTransform="matrix(1, 0, 0, 1, 0, 0)"
          xlinkHref="#ba153504-5bf4-4c43-a385-10b7c52f4eb6"
        />
      </defs>
      <g id="ad0f9dd3-05bb-4419-9ee1-ff0492846365" data-name="art">
        <g>
          <path
            d="M.14,134s-12,70,187,72,211.32,21,211.66,36l1.13-60.38S338.14,194,332.14,182s35-14,43-48Z"
            fill="#cea78d"
          />
          <ellipse cx="187.64" cy="134.5" rx="187.5" ry="52.5" fill="#f2d4c0" />
          <ellipse
            cx="187.64"
            cy="134.5"
            rx="158"
            ry="35"
            fill="#53326b"
            opacity="0.21"
          />
          <path
            d="M332.14,182c-1.68-3.36.32-5.93,4.25-8.64C322.92,181,298.14,187,250.14,193c-50.89,6.36-188.72.92-225.34-19.47,24,16.26,70.85,31.55,162.34,32.47,199,2,211.32,21,211.66,36l1.13-60.38S338.14,194,332.14,182Z"
            fill="#53326b"
            opacity="0.47"
          />
          <polygon
            points="225.14 170 233.14 176 249.14 166 260.14 176 279.26 163.14 286.14 166 298.14 158 292.46 151.23 225.14 170"
            fill="#53326b"
            opacity="0.21"
          />
          <g>
            <polygon
              points="266.04 143.62 279.24 136 292.46 143.63 279.26 151.23 266.04 143.62"
              fill="#c43d74"
            />
            <polygon
              points="266.04 143.62 266.04 158.86 279.24 166.48 279.26 151.23 266.04 143.62"
              fill="#f95387"
            />
            <polygon
              points="292.46 143.63 292.46 158.87 279.24 166.48 279.26 151.23 292.46 143.63"
              fill="#d84a7d"
            />
            <polyline
              points="272.65 162.67 272.64 147.42 279.26 143.61 285.84 147.44 285.87 162.67"
              fill="none"
              stroke="#cf8d53"
              strokeMiterlimit="10"
              strokeWidth="0.76"
            />
            <polyline
              points="272.65 139.81 279.26 143.61 285.83 139.81"
              fill="none"
              stroke="#cf8d53"
              strokeMiterlimit="10"
              strokeWidth="0.76"
            />
          </g>
          <g>
            <polygon
              points="231.04 140.05 252.08 127.91 273.14 140.07 252.1 152.18 231.04 140.05"
              fill="#567148"
            />
            <polygon
              points="231.04 140.05 231.04 164.34 252.08 176.48 252.1 152.18 231.04 140.05"
              fill="#729162"
            />
            <polygon
              points="273.14 140.07 273.14 164.35 252.08 176.48 252.1 152.18 273.14 140.07"
              fill="#3e5532"
            />
            <polyline
              points="241.57 170.4 241.56 146.11 252.1 140.04 262.59 146.14 262.63 170.4"
              fill="none"
              stroke="#cf8d53"
              strokeMiterlimit="10"
              strokeWidth="1.21"
            />
            <polyline
              points="241.57 133.99 252.1 140.04 262.58 133.99"
              fill="none"
              stroke="#cf8d53"
              strokeMiterlimit="10"
              strokeWidth="1.21"
            />
          </g>
          <g>
            <polygon
              points="209.04 153.62 222.24 146 235.46 153.63 222.26 161.23 209.04 153.62"
              fill="#d3be66"
            />
            <polygon
              points="209.04 153.62 209.04 168.86 222.24 176.48 222.26 161.23 209.04 153.62"
              fill="#e5d077"
            />
            <polygon
              points="235.46 153.63 235.46 168.87 222.24 176.48 222.26 161.23 235.46 153.63"
              fill="#b2a25f"
            />
            <polyline
              points="215.65 172.67 215.64 157.42 222.26 153.61 228.84 157.44 228.87 172.67"
              fill="none"
              stroke="#cf8d53"
              strokeMiterlimit="10"
              strokeWidth="0.76"
            />
            <polyline
              points="215.65 149.81 222.26 153.61 228.84 149.81"
              fill="none"
              stroke="#cf8d53"
              strokeMiterlimit="10"
              strokeWidth="0.76"
            />
          </g>
          <polygon
            points="28.05 137.49 28.05 108.34 78.52 137.49 78.52 166.63 28.05 137.49"
            fill="#7f7add"
          />
          <polygon
            points="84.1 163.4 91.14 166 101.14 159 84.14 151 84.1 163.4"
            fill="#53326b"
            opacity="0.21"
          />
          <polygon
            points="78.52 137.49 91.14 130.2 40.66 101.06 28.05 108.34 78.52 137.49"
            fill="#9c9ce5"
          />
          <polygon
            points="78.52 137.49 78.52 166.63 91.14 159.34 91.14 130.2 78.52 137.49"
            fill="#6868ba"
          />
          <ellipse cx="260.64" cy="201.5" rx="11.5" ry="1.5" fill="#eab82f" />
          <ellipse cx="299.64" cy="204.5" rx="11.5" ry="1.5" fill="#eab82f" />
          <ellipse cx="334.64" cy="206.5" rx="11.5" ry="1.5" fill="#eab82f" />
          <g>
            <g>
              <ellipse
                cx="322.43"
                cy="139.91"
                rx="26.07"
                ry="5.3"
                fill="#5b3570"
              />
              <path
                d="M354.62,119v7.34c0,.67-.69,1.31-1.95,1.91-4.5,2.12-16.34,3.64-30.24,3.64s-25.74-1.52-30.25-3.64c-1.26-.6-1.94-1.24-1.94-1.91V119c0,1.41,3,2.69,8.06,3.67a134.59,134.59,0,0,0,24.13,1.88,134.67,134.67,0,0,0,24.13-1.88C351.58,121.71,354.62,120.43,354.62,119Z"
                fill="#9fb8ad"
              />
              <path
                d="M354.46,117.39v7.34c0,.67-.69,1.31-1.95,1.9-4.51,2.13-16.35,3.65-30.25,3.65s-25.73-1.52-30.24-3.65c-1.26-.59-1.95-1.23-1.95-1.9v-7.34c0,1.4,3.05,2.69,8.06,3.67a134.89,134.89,0,0,0,24.13,1.87,134.93,134.93,0,0,0,24.14-1.87C351.41,120.08,354.46,118.79,354.46,117.39Z"
                fill="#9fb8ad"
              />
              <path
                d="M354.46,119.58v5.15c0,.67-.69,1.31-1.95,1.9-4.51,2.13-16.35,3.65-30.25,3.65s-25.73-1.52-30.24-3.65a3.93,3.93,0,0,1-1.78-1.34v1.07c0,.67.68,1.31,1.94,1.91,4.51,2.12,16.35,3.64,30.25,3.64s25.74-1.52,30.24-3.64c1.26-.6,1.95-1.24,1.95-1.91V119A1.19,1.19,0,0,1,354.46,119.58Z"
                fill="#434c68"
                opacity="0.56"
                style={{ mixBlendMode: 'multiply' }}
              />
              <path
                d="M354.46,117.55c0,1.41-3,2.69-8.06,3.67a134.8,134.8,0,0,1-24.14,1.88,134.76,134.76,0,0,1-24.13-1.88c-5-1-8.06-2.26-8.06-3.67,0-3.07,14.42-5.55,32.19-5.55S354.46,114.48,354.46,117.55Z"
                fill="#c5d7bd"
              />
              <image
                width="81"
                height="79"
                transform="translate(306.14 87)"
                xlinkHref="data:image/png;base64,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"
              />
              <path
                d="M348.46,119.51c0,1.14-2.46,2.18-6.51,3a126.1,126.1,0,0,1-39,0c-4.06-.79-6.52-1.83-6.52-3,0-2.48,11.66-4.49,26-4.49S348.46,117,348.46,119.51Z"
                fill="#434c68"
                style={{ mixBlendMode: 'multiply' }}
              />
              <path
                d="M339,121c0,.72-1.57,1.38-4.15,1.89a80.82,80.82,0,0,1-24.84,0c-2.58-.51-4.15-1.17-4.15-1.89,0-1.58,7.42-2.86,16.57-2.86S339,119.4,339,121Z"
                fill="#9fb8ad"
                stroke="#efe922"
                strokeMiterlimit="10"
                strokeWidth="0.08"
              />
              <path
                d="M336.1,121c0,.59-1.3,1.14-3.43,1.55a66,66,0,0,1-20.49,0c-2.13-.41-3.42-1-3.42-1.55,0-1.31,6.12-2.36,13.67-2.36S336.1,119.67,336.1,121Z"
                fill="#383e56"
                stroke="#efe922"
                strokeMiterlimit="10"
                strokeWidth="0.33"
              />
              <path
                d="M333.79,121c0,.49-1.07,1-2.84,1.29a55.32,55.32,0,0,1-17,0c-1.77-.34-2.84-.8-2.84-1.29,0-1.09,5.08-2,11.36-2S333.79,119.89,333.79,121Z"
                fill="#9fb8ad"
                stroke="#efe922"
                strokeMiterlimit="10"
                strokeWidth="0.08"
              />
              <path
                d="M331.36,121c0,.39-.84.74-2.23,1a43.42,43.42,0,0,1-13.4,0c-1.39-.28-2.24-.63-2.24-1,0-.85,4-1.54,8.94-1.54S331.36,120.13,331.36,121Z"
                fill="#383e56"
                stroke="#efe922"
                strokeMiterlimit="10"
                strokeWidth="0.33"
              />
              <path
                d="M342.62,125.71v3.43s5.88-.66,8.16-1.88V124A35.17,35.17,0,0,1,342.62,125.71Z"
                fill="url(#ef6373f0-66c7-4d3c-b248-ffa9e6daad18)"
              />
              <image
                width="78"
                height="76"
                transform="translate(298.14 90)"
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAE4AAABMCAYAAADDYoEWAAAACXBIWXMAAAsSAAALEgHS3X78AAAD+UlEQVR4Xu2au27jMBBFL7MCNkacIkV6F+5S5gf1gynTLFy4d5EiDjYLOOEW1EgkNTQlmqSFYA5g2HqCczCkyJGV1hrCfG5iJwg8Ii4REZeIiEtExCUi4hIRcYmIuEREXCIiLhERl4iIS0TEJSLiEhFxiSxXnFIKSqnYaddCLaKQOVfQAhp9PXFzZYW4UgD1xeUS5lM5kHripgmLnRNvbKWAyouLC7OOt8GTmOPnG144sLLizkvrjrXe7tfANU9eQ1v6EQ6gYHDlxIWlMcJCskLYElv6wQdSKMCa4pguyQk7BCQ+Mg0lga290z2vUIBlxAWltd2mLywkK4QvcSSwuLz84vguqkxQMWHv3fazuxsv3fe911hOYAtw3TZzoE3shAxEuiMn68275pmCVq5Eus+oGyvEnroXkjfjJmUbBWsL80UBeOq+X0dHADzocRaSvDpZV1qcGo9rBxWWdlTYgmcHAGursb48WxzAyssYbKXqiJ9tgCvtqLC1pJ3+KucDAFsA26MCjt01b8rt3nTvuVObNPJl3Kxss6RtOxEkCBvw7M1XszIN3lH2UebVzboKDwcu26xMAzppG7Pr9MFnTLMxAZ/2ysg7KtN13xR6OQdl5L2q8UojL6W6aqC7ULYB/XhG0k4fypH2/anw/Tls98c35pptdw8A5p7vw7kuRbpuHnHs07QFn20RfGH+dhR7rGvHh+NFh0nkETcLGtvgZhuAs4Lo2CjrAHY6U5jK4vwVQYCvf8r5TGLivTNRUZw1BtGTdGq2EX7WAda9gDPjXHYqivtZVBRnLdD7OdgeaO7M75vb+PSBzmnudD+v29mrCb8IUI6K4oBhiRTh12/tfCYx8d6ZqCwOMDN9mLVns9KTs87PtmalzfoV6O9ZkTzi2GVMi2H2zlVvA9zcakegvx1lVCVxybTkyiNuTKBx93roUms9yjrKPGAsrD++t7KNxjdaq7JkEeVTYa36pM0s/lEPs/oHbSataw0czdrztDfHaE06Ym++aJEPe5FP+Iv8cuSrjgBnKiRcEdMvK1lX9ZWSjl4WvLqcXRkBosXMjMGW6qoe3Fj3giFb1hq79TDYNyvtfAAjbLfWY2lEvWwDymccIKXziZx9NchVS6a8rLHHMe6NF/skLdZNgSoPB2iMamIU6EENAv7AkugFacu6t/YHpzlZJXHkzzhAXkhfhPwFIhH5080FyN+8LiBe42e6cAjn+PmGFw6svDgiLhCIv5GKN7ZSQPXEEdMEzqdyIPXFEbkEXimA64mzmStxAY1ehjgOkrnQBi5X3MKpVFb6eYi4RERcIiIuERGXiIhLRMQlIuISEXGJiLhERFwiIi4REZeIiEtExCXyH+VvEWPSp0F0AAAAAElFTkSuQmCC"
              />
              <path
                d="M296.36,119.51c1.59.14,3.17.38,4.75.61s3.15.51,4.71.86c-1.59-.15-3.17-.39-4.75-.62S297.92,119.85,296.36,119.51Z"
                fill="#1ef9aa"
              />
              <path
                d="M301.09,116.93c.94.47,1.83,1,2.73,1.55s1.76,1.12,2.59,1.76c-.94-.46-1.83-1-2.72-1.55S301.92,117.57,301.09,116.93Z"
                fill="#1ef9aa"
              />
              <path
                d="M306.41,116A18.07,18.07,0,0,1,308,117.5a19.55,19.55,0,0,1,1.45,1.69,18,18,0,0,1-1.62-1.52A19.69,19.69,0,0,1,306.41,116Z"
                fill="#1ef9aa"
              />
              <path
                d="M311.14,115.46a11,11,0,0,1,.68,1.53,11.09,11.09,0,0,1,.45,1.62,11,11,0,0,1-.68-1.53A11.09,11.09,0,0,1,311.14,115.46Z"
                fill="#1ef9aa"
              />
              <path
                d="M314.85,115.21a10.35,10.35,0,0,1,.55,3.18,10.35,10.35,0,0,1-.55-3.18Z"
                fill="#1ef9aa"
              />
              <path
                d="M318.12,115.08a10.33,10.33,0,0,1,0,3.14,9.55,9.55,0,0,1,0-3.14Z"
                fill="#1ef9aa"
              />
              <path
                d="M321,115.08a9.75,9.75,0,0,1,0,3,9,9,0,0,1,0-3Z"
                fill="#1ef9aa"
              />
              <path
                d="M324.21,115.08a8.79,8.79,0,0,1,0,1.54,8.7,8.7,0,0,1-.27,1.51,9.77,9.77,0,0,1,.3-3Z"
                fill="#1ef9aa"
              />
              <path
                d="M326.75,115.08a10.84,10.84,0,0,1-.69,3.11,9.25,9.25,0,0,1,.22-1.58A10.39,10.39,0,0,1,326.75,115.08Z"
                fill="#1ef9aa"
              />
              <path
                d="M330,115.21a9.81,9.81,0,0,1-.47,1.54,10.23,10.23,0,0,1-.71,1.45,11.93,11.93,0,0,1,.48-1.54A10.17,10.17,0,0,1,330,115.21Z"
                fill="#1ef9aa"
              />
              <path
                d="M332.64,115.38a11.82,11.82,0,0,1-.78,1.55,9.86,9.86,0,0,1-1,1.43,12.48,12.48,0,0,1,.78-1.55A11.74,11.74,0,0,1,332.64,115.38Z"
                fill="#1ef9aa"
              />
              <path
                d="M336,115.67a14.11,14.11,0,0,1-1.06,1.55,15,15,0,0,1-1.26,1.39,14.45,14.45,0,0,1,2.32-2.94Z"
                fill="#1ef9aa"
              />
              <path
                d="M339,116a20.9,20.9,0,0,1-1.73,1.67,19.23,19.23,0,0,1-1.89,1.48A24.74,24.74,0,0,1,339,116Z"
                fill="#1ef9aa"
              />
              <path
                d="M342.3,116.61c-.74.61-1.54,1.15-2.32,1.69s-1.6,1-2.46,1.5c.74-.62,1.53-1.16,2.32-1.7A27.73,27.73,0,0,1,342.3,116.61Z"
                fill="#1ef9aa"
              />
              <path
                d="M346,117.58c-1.11.66-2.26,1.23-3.4,1.81S340.23,120.5,339,121c1.11-.66,2.26-1.23,3.41-1.81S344.76,118.06,346,117.58Z"
                fill="#1ef9aa"
              />
              <path
                d="M347,121c-1.47.25-3,.4-4.43.57s-3,.28-4.45.33c1.47-.26,2.95-.41,4.43-.58S345.55,121,347,121Z"
                fill="#1ef9aa"
              />
              <path
                d="M338.16,123.08a2.75,2.75,0,0,1-.81-.2,3,3,0,0,1-.71-.44,3,3,0,0,1,.81.21A2.75,2.75,0,0,1,338.16,123.08Z"
                fill="#1ef9aa"
              />
              <path
                d="M300.31,121.88c1-.11,2-.11,3.05-.13s2,0,3.05.13c-1,.1-2,.1-3.05.12S301.32,122,300.31,121.88Z"
                fill="#1ef9aa"
              />
              <path
                d="M307.16,123.14a3.22,3.22,0,0,1,.76-.39,2.55,2.55,0,0,1,.83-.16,2.56,2.56,0,0,1-.75.39A2.61,2.61,0,0,1,307.16,123.14Z"
                fill="#1ef9aa"
              />
              <path
                d="M352.71,128.43l-2,2-7.4,7.15c0,2-9.35,3.55-20.87,3.48s-20.84-1.72-20.83-3.71l-6.84-6.76-2.5-2.48c4.5,2.15,16.33,3.73,30.22,3.81S348.19,130.54,352.71,128.43Z"
                fill="#434c68"
              />
              <path
                d="M334.38,126.61V130a30.54,30.54,0,0,0,5.63-.41V126.2A33.9,33.9,0,0,1,334.38,126.61Z"
                fill="url(#f2d7ddae-7d23-41a5-bf37-52c032b62bb4)"
              />
              <path
                d="M343.26,137.57l.35-.34c-20.34,2.49-34.22,1.28-42.38-.22l.33.33c0,2,9.32,3.65,20.83,3.71S343.25,139.56,343.26,137.57Z"
                fill="#434c68"
                style={{ mixBlendMode: 'multiply' }}
              />
              <ellipse
                cx="322.2"
                cy="118.34"
                rx="30.55"
                ry="6.19"
                strokeMiterlimit="10"
                strokeWidth="0.08"
                opacity="0.76"
                fill="url(#fe9792e0-e9ff-4f32-a022-f189d8953ced)"
                stroke="url(#ba153504-5bf4-4c43-a385-10b7c52f4eb6)"
                style={{ mixBlendMode: 'color-dodge' }}
              />
            </g>
            <g>
              <g>
                <path
                  d="M313.76,59s16,15,25.92,12.48c-5.44-9-30.08-20.79-30.08-20.79a2,2,0,0,1-1.6,2.56Z"
                  fill="#e545b8"
                />
                <path
                  d="M309.6,53.26s-4.48,2.56-6.08-1.28,0-5.12-1-6.72c3.84.32,2.24.64,4.48,1.6S312.16,51,309.6,53.26Z"
                  fill="#9a0024"
                />
              </g>
              <path
                d="M319.84,56.14c-5.26-3-9.28-4.8-9.28-4.8a2.34,2.34,0,0,1-1.92,2.56l5.76,5.75s.6.57,1.64,1.46A19,19,0,0,0,319.84,56.14Z"
                fill="#f2f2d1"
              />
              <g>
                <path
                  d="M336.16,49.74,319.52,66.69a3.24,3.24,0,0,0,3.52,3.2l17-17A10.23,10.23,0,0,1,336.16,49.74Z"
                  fill="#eaab71"
                />
                <line
                  x1="336.16"
                  y1="49.74"
                  x2="320.48"
                  y2="66.69"
                  fill="none"
                  stroke="#ebc7ae"
                  strokeLinecap="round"
                  strokeLinejoin="bevel"
                  strokeWidth="1.6"
                />
                <line
                  x1="339.84"
                  y1="53.1"
                  x2="322.88"
                  y2="69.09"
                  fill="none"
                  stroke="#b08b32"
                  strokeLinecap="round"
                  strokeLinejoin="bevel"
                  strokeWidth="1.6"
                />
                <path
                  d="M340.58,47.18l-4.41,1.44a1.18,1.18,0,0,0-.43,2l3.45,3.11a1.19,1.19,0,0,0,1.95-.64l1-4.54A1.18,1.18,0,0,0,340.58,47.18Z"
                  fill="#f9edcd"
                />
                <path
                  d="M341.73,50.3l.53-2.51a.73.73,0,0,0-.94-.85l-2.17.71A3.52,3.52,0,0,0,341.73,50.3Z"
                  fill="#751975"
                />
              </g>
            </g>
            <ellipse
              cx="322.22"
              cy="58.45"
              rx="39.58"
              ry="20.45"
              fill="none"
              stroke="#83e8d8"
              strokeMiterlimit="10"
              strokeWidth="6.6"
            />
            <image
              width="159"
              height="120"
              transform="translate(244.14)"
              xlinkHref="data:image/png;base64,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"
            />
            <ellipse
              cx="322.22"
              cy="58.45"
              rx="39.58"
              ry="20.45"
              fill="none"
              stroke="#e1e1ef"
              strokeMiterlimit="10"
              strokeWidth="1.32"
            />
            <path
              d="M347.14,75c0,7.18-17.82,48-25,48s-26-38.82-26-46,18.82,2,26,2S347.14,67.82,347.14,75Z"
              strokeMiterlimit="10"
              strokeWidth="0.08"
              opacity="0.44"
              fill="url(#ba9af3b4-47a9-4f4b-a282-329720f796fe)"
              stroke="url(#ff3e5164-0cfa-4a27-a567-5f0cae925559)"
              style={{ mixBlendMode: 'color-dodge' }}
            />
          </g>
        </g>
        <g className="text" transform="translate(-75 -45)">
          <path
            d="M234.19,213.79a.81.81,0,0,0-.85-.68h-.2l-.32,0-.58,0q-1-2.84-2-5.18c-.68-1.56-1.26-2.82-1.74-3.77a1.42,1.42,0,0,0-1.13-.8l-.47,0h-.58a10.62,10.62,0,0,0-1.2.07c-.43,0-.86.11-1.26.18a1.48,1.48,0,0,0-1.06.92c-.55,1.33-1.1,2.74-1.67,4.23s-1.11,3-1.61,4.53c-.5,0-.85-.07-1.05-.07a.89.89,0,0,0-.54.16.77.77,0,0,0-.31.55,7.52,7.52,0,0,0-.08.91c0,.34,0,.72,0,1.12s.31.8.94.89c-.11.38-.21.74-.3,1.09s-.15.66-.19.91a1.48,1.48,0,0,0-.06.32,1.28,1.28,0,0,0,0,.17.75.75,0,0,0,.59.77,10.33,10.33,0,0,0,1.42.33,8.92,8.92,0,0,0,1.44.14.85.85,0,0,0,.91-.8c.08-.4.17-.82.26-1.25s.2-.87.31-1.32l1.67.07,1.72,0c.91,0,1.81,0,2.7-.07l.65,2.44a1.39,1.39,0,0,0,.33.62.9.9,0,0,0,.63.2,9.44,9.44,0,0,0,1.52-.13,13.71,13.71,0,0,0,1.44-.34.72.72,0,0,0,.56-.75,1.21,1.21,0,0,0,0-.18c0-.07,0-.2-.08-.38s-.14-.54-.23-.86-.18-.66-.29-1a1.1,1.1,0,0,0,.61-.23,1.13,1.13,0,0,0,.28-.66,2,2,0,0,0,0-.41v-.39A5.57,5.57,0,0,0,234.19,213.79Zm-8.42-.42h-1.92c.26-.89.55-1.79.84-2.71s.62-1.85,1-2.82q.58,1.26,1.11,2.67c.34.94.66,1.88,1,2.84Z"
            fill="#fff"
          />
          <path
            d="M244.45,211.18a7.06,7.06,0,0,0-.14-1.19,3.13,3.13,0,0,0-.47-1.1,1.13,1.13,0,0,0-1-.51,4.4,4.4,0,0,0-1.74.35,5.41,5.41,0,0,0-1.47.94,3.5,3.5,0,0,0,0-.37c0-.13,0-.24,0-.34a.74.74,0,0,0-.12-.44.54.54,0,0,0-.47-.17l-.67,0c-.27,0-.54,0-.8.06l-.77.08a4.64,4.64,0,0,0-.66.12.63.63,0,0,0-.55.48,5,5,0,0,0-.11.9c0,.28,0,.56,0,.84v.85c0,1.21,0,2.44.12,3.66s.18,2.44.3,3.62a1.83,1.83,0,0,0,.29.85,1.35,1.35,0,0,0,1,.32,2,2,0,0,0,.35,0h.81a2.05,2.05,0,0,0,.37,0,1.78,1.78,0,0,0,1-.25.75.75,0,0,0,.25-.61c0-.13,0-.38-.06-.76s-.08-.86-.12-1.43-.08-1.23-.11-2-.06-1.54-.06-2.38a6.4,6.4,0,0,1,.66-.49c.19-.11.38-.22.6-.33a4.29,4.29,0,0,1,.1.73c0,.28,0,.5,0,.68a1.35,1.35,0,0,0,.21.73.66.66,0,0,0,.61.34,2.15,2.15,0,0,0,.75-.17,6.64,6.64,0,0,0,.77-.34,2.59,2.59,0,0,0,.91-.76,1.62,1.62,0,0,0,.24-.86C244.47,212,244.46,211.61,244.45,211.18Z"
            fill="#fff"
          />
          <path
            d="M252.81,209.84a1,1,0,0,0-.65-.29c-.28-.05-.56-.08-.84-.11l-.8-.08c0-.28,0-.58,0-.9s0-.63.05-.93,0-.55,0-.76,0-.35,0-.43a1.28,1.28,0,0,0-.21-.79.9.9,0,0,0-.75-.27,12.27,12.27,0,0,0-1.7.1,2.69,2.69,0,0,0-1,.28.92.92,0,0,0-.43.49,2.59,2.59,0,0,0-.13.75c0,.35,0,.67,0,1s0,.6,0,.89v.66c-.31,0-.56.07-.75.1a1,1,0,0,0-.44.2.74.74,0,0,0-.23.38,3.4,3.4,0,0,0,0,.63c0,.13,0,.28,0,.45l0,.51a1,1,0,0,0,.27.72,1.46,1.46,0,0,0,.72.22l.61.07c.08,1.16.16,2.27.27,3.35s.23,2.17.38,3.28a1.26,1.26,0,0,0,.29.76,1,1,0,0,0,.67.2,10.6,10.6,0,0,0,1.78-.14,1.08,1.08,0,0,0,.67-.28,1,1,0,0,0,.18-.63c0-.16,0-.49,0-1s-.05-1.06-.09-1.68-.08-1.28-.11-1.95,0-1.26-.07-1.78l.55,0,.7-.07a1.4,1.4,0,0,0,.74-.23,1,1,0,0,0,.33-.64c0-.22.06-.46.09-.71s0-.47,0-.63A1,1,0,0,0,252.81,209.84Z"
            fill="#fff"
          />
        </g>
      </g>
      {resources && (
        <g className="resources-wrap" transform="translate(95, 0)">
          <ResourceLink
            r={resources[0]}
            svgComponent={resource1SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[0], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
          <ResourceLink
            r={resources[1]}
            svgComponent={resource2SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[1], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
          <ResourceLink
            r={resources[2]}
            svgComponent={resource3SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[2], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
          <ResourceLink
            r={resources[3]}
            svgComponent={resource4SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[3], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
          <ResourceLink
            r={resources[4]}
            svgComponent={resource5SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[4], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
          <ResourceLink
            r={resources[5]}
            svgComponent={resource6SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[5], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
        </g>
      )}
    </g>
  );
};
export default ArtLink;
